t = require('app/scripts/views/internal/teacup-with-helpers')()

module.exports = t.renderable ({ enterpriseName, message }) ->
  t.p '.u-bottom', ->
    t.h3 ->
      t.span '.icon-sm.icon-warning'
      t.text "Message from #{ enterpriseName }:"
      t.a '.header-banner-link-left.quiet.js-dismiss-enterprise-notification-banner.u-float-right', { href: "#" }, ->
        t.icon 'close'
    t.span '.message', ->
      t.raw message
